import _get from 'lodash/get';
import _findKey from 'lodash/findKey';
import type { RootState } from 'reducers/index';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';

export const getEntitiesById = (state: RootState): Record<number, GenericEntityType> =>
  _get(state, 'website.entities.byId', {});

export const getEntitiesOrderedIds = (state: RootState): number[] =>
  _get(state, 'website.entities.orderedIds', []);

export const getSelectedEntityId = (state: RootState): string | undefined =>
  _get(state, 'website.entities.selectedEntityId', undefined);

export const getSelectedEntity = (state: RootState): GenericEntityType | Record<string, unknown> =>
  _get(state, `website.entities.byId.${getSelectedEntityId(state)}`, {});

export const getIsEntityLoading = (state: RootState): boolean =>
  _get(state, 'website.entities.busy', false);

export const getEntityByHash = (
  state: RootState,
  hash: string
): GenericEntityType | Record<string, unknown> => {
  const entitiesById = getEntitiesById(state);
  const id = _findKey(entitiesById, { hash });
  return id ? _get(entitiesById, id, {}) : {};
};

export default {
  getEntitiesById,
  getEntitiesOrderedIds,
  getSelectedEntityId,
  getSelectedEntity,
  getIsEntityLoading,
  getEntityByHash,
};
